import React, { use, useEffect } from 'react';
import RedesContacto from './RedesContacto';
import Select from 'react-select';
export default function VulneracionTrata({ 
	register, 
    setValue, 
    getValues,
    watch,
	append,
	remove,
	parentescos = [], 
	errors = {}, 
	useAuth, 
	apiService, 
	Cargando, 
	setCargando, 
	idCabezaFamilia, 
	user, 
	token, 
	Mensaje, 
	paises = [],
	barrios = [],
	municipiosdto,
    tiposDocumentos = []
}) {
	const [tiposTrata, setTiposTrata] = React.useState([]);
    const [tipoContactoRedCaptadora, setTipoContactoRedCaptadora] = React.useState([]);
    const [promesasCaptacion, setPromesasCaptacion] = React.useState([]);
    const [mecanismosexplotacion, setMecanismosexplotacion] = React.useState([]);
    const [tratadocumentoretenido, setTratadocumentoretenido] = React.useState([]);
    const [trataredsegura, setTrataredsegura] = React.useState([]);
    const [antecedentetrata, setAntecedentetrata] = React.useState([]);
    const [requerimientoapoyosexual, setRequerimientoapoyosexual] = React.useState([]);
    const [tipovaloracionriesgotrata, setTipovaloracionriesgotrata] = React.useState([]);
    const [tipoacompespecializadotrata, setTipoacompespecializadotrata] = React.useState([]);
    const [tipotramiteregulacion, setTipotramiteregulacion] = React.useState([]);
    const [tratarequierederivacionprograma, setTratarequierederivacionprograma] = React.useState([]);
    const [trataexpectativavida, setTrataexpectativavida] = React.useState([]);
    const [tratanecesidadesinmediata, setTratanecesidadesinmediata] = React.useState([]);
    const [mecanismosexplotacionSeleccionado, setMecanismosexplotacionSeleccionado] = React.useState([]);
    const [trataexpectativavidaSeleccionado, setTrataexpectativavidaSeleccionado] = React.useState([]);
    const [tratanecesidadesinmediataSeleccionado, setTratanecesidadesinmediataSeleccionado] = React.useState([]);
    
	const ObtenerDatosSelects = async () => {
		let url = `/ddhh/vulneraciones/obtenerdatosselectstrata`;
		try {
			setCargando(true);
			const response = await apiService.get(url, token);
			const result = await response.data;
			setTipoContactoRedCaptadora(result.tipoContactoRedCaptadora);
			setPromesasCaptacion(result.promesasCaptacion);
			setMecanismosexplotacion(result.mecanismosexplotacion);
			setTratadocumentoretenido(result.tratadocumentoretenido);
			setTrataredsegura(result.trataredsegura);
			setAntecedentetrata(result.antecedentetrata);
			setRequerimientoapoyosexual(result.requerimientoapoyosexual);
			setTipovaloracionriesgotrata(result.tipovaloracionriesgotrata);
			setTipoacompespecializadotrata(result.tipoacompespecializadotrata);
			setTipotramiteregulacion(result.tipotramiteregulacion);
			setTratarequierederivacionprograma(result.tratarequierederivacionprograma);
			setTrataexpectativavida(result.trataexpectativavida);
			setTratanecesidadesinmediata(result.tratanecesidadesinmediata);
			setTiposTrata(result.tipostrata);
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setCargando(false);
		}
	}
	useEffect(() => {
		ObtenerDatosSelects();
	}, []);
    const tipoTrataSeleccionado = watch ? watch('datosVulneracion.intTipotrataid') : '';
    useEffect(() => {
        if (tiposTrata.length === 0 || !tipoTrataSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intTipotrataid', String(tipoTrataSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tiposTrata, tipoTrataSeleccionado, setValue]);
    const tipoContactoRedCaptadoraSeleccionado = watch ? watch('datosVulneracion.intIdtipocontactoredcaptadora') : '';
    useEffect(() => {
        if (tipoContactoRedCaptadora.length === 0 || !tipoContactoRedCaptadoraSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdtipocontactoredcaptadora', String(tipoContactoRedCaptadoraSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoContactoRedCaptadora, tipoContactoRedCaptadoraSeleccionado, setValue]);
    const promesasCaptacionSeleccionada = watch ? watch('datosVulneracion.intIdpromesascaptacion') : '';
    useEffect(() => {
        if (promesasCaptacion.length === 0 || !promesasCaptacionSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intIdpromesascaptacion', String(promesasCaptacionSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [promesasCaptacion, promesasCaptacionSeleccionada, setValue]);
    useEffect(() => {
        if (mecanismosexplotacion.length === 0) {
            return;
        }

        const mecanismosexplotacionGuardado = watch
            ? watch('datosVulneracion.strIdmecanismoexplotacion')
            : getValues('datosVulneracion.strIdmecanismoexplotacion');

        const mecanismosexplotacionNormalizado = Array.isArray(mecanismosexplotacionGuardado)
            ? mecanismosexplotacionGuardado.map(String)
            : String(mecanismosexplotacionGuardado || '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);

        if (mecanismosexplotacionNormalizado.length === 0) {
            setMecanismosexplotacionSeleccionado([]);
            return;
        }

        const seleccionados = mecanismosexplotacion
            .filter((option) => mecanismosexplotacionNormalizado.includes(String(option.id)))
            .map((option) => ({
                value: String(option.id),
                label: option.strNombre,
            }));

        setMecanismosexplotacionSeleccionado(seleccionados);
    }, [mecanismosexplotacion, watch, getValues]);
    const ActualizarMecanismosexplotacion = (opcionesSeleccionadas) => {
        const seleccionadas = opcionesSeleccionadas || [];
        setMecanismosexplotacionSeleccionado(seleccionadas);
        setValue(
            'datosVulneracion.strIdmecanismoexplotacion',
            seleccionadas.map((opcion) => String(opcion.value)).join(','),
            {
                shouldValidate: true,
                shouldDirty: true,
            }
        );
    };
    const tratadocumentoretenidoSeleccionado = watch ? watch('datosVulneracion.intIddocumentosretenidos') : '';
    useEffect(() => {
        if (tratadocumentoretenido.length === 0 || !tratadocumentoretenidoSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIddocumentosretenidos', String(tratadocumentoretenidoSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tratadocumentoretenido, tratadocumentoretenidoSeleccionado, setValue]);
    const trataredseguraSeleccionada = watch ? watch('datosVulneracion.intIdtrataredsegura') : '';
    useEffect(() => {
        if (trataredsegura.length === 0 || !trataredseguraSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intIdtrataredsegura', String(trataredseguraSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [trataredsegura, trataredseguraSeleccionada, setValue]);
    const antecedentetrataSeleccionado = watch ? watch('datosVulneracion.intIdantecedentestrata') : '';
    useEffect(() => {
        if (antecedentetrata.length === 0 || !antecedentetrataSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdantecedentestrata', String(antecedentetrataSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [antecedentetrata, antecedentetrataSeleccionado, setValue]);
    const requerimientoapoyosexualSeleccionado = watch ? watch('datosVulneracion.intIdrequerimientoapoyoviolsexual') : '';
    useEffect(() => {
        if (requerimientoapoyosexual.length === 0 || !requerimientoapoyosexualSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdrequerimientoapoyoviolsexual', String(requerimientoapoyosexualSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [requerimientoapoyosexual, requerimientoapoyosexualSeleccionado, setValue]);
    const tipovaloracionriesgotrataSeleccionado = watch ? watch('datosVulneracion.intIdtipovaloracionriesgotrata') : '';
    useEffect(() => {
        if (tipovaloracionriesgotrata.length === 0 || !tipovaloracionriesgotrataSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdtipovaloracionriesgotrata', String(tipovaloracionriesgotrataSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipovaloracionriesgotrata, tipovaloracionriesgotrataSeleccionado, setValue]);
    const tipoacompespecializadotrataSeleccionado = watch ? watch('datosVulneracion.intIdtipoacompespecializadotrata') : '';
    useEffect(() => {
        if (tipoacompespecializadotrata.length === 0 || !tipoacompespecializadotrataSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdtipoacompespecializadotrata', String(tipoacompespecializadotrataSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoacompespecializadotrata, tipoacompespecializadotrataSeleccionado, setValue]);
    const tipotramiteregulacionSeleccionado = watch ? watch('datosVulneracion.intIdtipotramiteregulacion') : '';
    useEffect(() => {
        if (tipotramiteregulacion.length === 0 || !tipotramiteregulacionSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdtipotramiteregulacion', String(tipotramiteregulacionSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipotramiteregulacion, tipotramiteregulacionSeleccionado, setValue]);
    const tratarequierederivacionprogramaSeleccionado = watch ? watch('datosVulneracion.intIdtratarequierederivacionprograma') : '';
    useEffect(() => {
        if (tratarequierederivacionprograma.length === 0 || !tratarequierederivacionprogramaSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intIdtratarequierederivacionprograma', String(tratarequierederivacionprogramaSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tratarequierederivacionprograma, tratarequierederivacionprogramaSeleccionado, setValue]);
    useEffect(() => {
        if (trataexpectativavida.length === 0) {
            return;
        }

        const trataExpectativasVidaGuardado = watch
            ? watch('datosVulneracion.strTrataexpectativavida')
            : getValues('datosVulneracion.strTrataexpectativavida');

        const trataexpectativavidaNormalizado = Array.isArray(trataExpectativasVidaGuardado)
            ? trataExpectativasVidaGuardado.map(String)
            : String(trataExpectativasVidaGuardado || '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);

        if (trataexpectativavidaNormalizado.length === 0) {
            setTrataexpectativavidaSeleccionado([]);
            return;
        }

        const seleccionados = trataexpectativavida
            .filter((option) => trataexpectativavidaNormalizado.includes(String(option.id)))
            .map((option) => ({
                value: String(option.id),
                label: option.strNombre,
            }));

        setTrataexpectativavidaSeleccionado(seleccionados);
    }, [trataexpectativavida, watch, getValues]);
    const ActualizarTrataExpectativaVida = (opcionesSeleccionadas) => {
        const seleccionadas = opcionesSeleccionadas || [];
        setTrataexpectativavidaSeleccionado(seleccionadas);
        setValue(
            'datosVulneracion.strTrataexpectativavida',
            seleccionadas.map((opcion) => String(opcion.value)).join(','),
            {
                shouldValidate: true,
                shouldDirty: true,
            }
        );
    };
    useEffect(() => {
        if (tratanecesidadesinmediata.length === 0) {
            return;
        }

        const necesidadInmediataGuardado = watch
            ? watch('datosVulneracion.strNecesidadinmediata')
            : getValues('datosVulneracion.strNecesidadinmediata');

        const necesidadInmediataNormalizado = Array.isArray(necesidadInmediataGuardado)
            ? necesidadInmediataGuardado.map(String)
            : String(necesidadInmediataGuardado || '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);

        if (necesidadInmediataNormalizado.length === 0) {
            setTratanecesidadesinmediataSeleccionado([]);
            return;
        }

        const seleccionados = tratanecesidadesinmediata
            .filter((option) => necesidadInmediataNormalizado.includes(String(option.id)))
            .map((option) => ({
                value: String(option.id),
                label: option.strNombre,
            }));

        setTratanecesidadesinmediataSeleccionado(seleccionados);
    }, [tratanecesidadesinmediata, watch, getValues]);
    const ActualizarNecesidadInmediata = (opcionesSeleccionadas) => {
        const seleccionadas = opcionesSeleccionadas || [];
        setTratanecesidadesinmediataSeleccionado(seleccionadas);
        setValue(
            'datosVulneracion.strNecesidadinmediata',
            seleccionadas.map((opcion) => String(opcion.value)).join(','),
            {
                shouldValidate: true,
                shouldDirty: true,
            }
        );
    };
	return (
		<div className="card">
			<div className="card-header">
				<div className="col-md-12">
					<h6 className="text-primary font-weight-bold mb-3">Datos de Trata de Personas</h6>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intTipotrataid">Tipo de trata</label>
                            <select id="datosVulneracion.intTipotrataid" className="form-control" {...register('datosVulneracion.intTipotrataid' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {tiposTrata.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intTipotrataid && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intPaiscaptacion">Pa&iacute;s de captaci&oacute;n</label>
							<select id="datosVulneracion.intPaiscaptacion" className="form-control" {...register('datosVulneracion.intPaiscaptacion' , { required: true })}>
                                <option value="">Seleccione...</option>
								{paises.map((option, idx) => (
									<option key={option.id || idx} value={option.id}>{option.pais + ' - ' + option.iso}</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intPaiscaptacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strCiudadcaptacion">Ciudad de captaci&oacute;n</label>
							<input
								id="datosVulneracion.strCiudadcaptacion"
								type="text"
								className="form-control"
								{...register('datosVulneracion.strCiudadcaptacion', { required: true })}
							/>
                            {errors.datosVulneracion?.strCiudadcaptacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intPaisexplotacion">Pa&iacute;s de explotaci&oacute;n</label>
							<select id="datosVulneracion.intPaisexplotacion" className="form-control" {...register('datosVulneracion.intPaisexplotacion' , { required: true })}>
                                <option value="">Seleccione...</option>
								{paises.map((option, idx) => (
									<option key={option.id || idx} value={option.id}>{option.pais + ' - ' + option.iso}</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intPaisexplotacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strCiudadexplotacion">Ciudad de explotaci&oacute;n</label>
							<input
								id="datosVulneracion.strCiudadexplotacion"
								type="text"
								className="form-control"
								{...register('datosVulneracion.strCiudadexplotacion')}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-8">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strTrazabilidad">Relato de la situaci&oacute;n de la v&iacute;ctima</label>
							<textarea
								id="datosVulneracion.strTrazabilidad"
								rows="3"
								className="form-control"
								{...register('datosVulneracion.strTrazabilidad')}
							/>
						</div>
					</div>
				</div>
				<hr />
				<RedesContacto
					register={register}
					getValues={getValues}
					watch={watch}
					append={append}
					remove={remove}
					errors={errors}
					paises={paises}
					barrios={barrios}
					municipiosdto={municipiosdto}
					parentescos={parentescos}
					tiposDocumentos={tiposDocumentos}
				/>
                <hr />
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="bolAsistenciainmediata">Asistencia Inmediata</label>
                            <select
                                className="form-control"
                                id="bolAsistenciainmediata"
                                {...register('datosVulneracion.bolAsistenciainmediata')}
                            >
                                <option value="">Seleccione...</option>
                                <option value="true">SI</option>
                                <option value="false">NO</option>
                            </select>
                            {errors.datosVulneracion?.bolAsistenciainmediata && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtipocontactoredcaptadora">¿c&oacute;mo se estableci&oacute; el primer contacto con la persona o con la red captadora?</label>
                            <select
                                id="intIdtipocontactoredcaptadora"
                                className="form-control"
                                {...register('datosVulneracion.intIdtipocontactoredcaptadora', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoContactoRedCaptadora.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtipocontactoredcaptadora && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdpromesascaptacion">¿qu&eacute; promesas u ofertas le realizar&oacute;n inicialmente?</label>
                            <select
                                id="intIdpromesascaptacion"
                                className="form-control"
                                {...register('datosVulneracion.intIdpromesascaptacion', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {promesasCaptacion.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdpromesascaptacion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="strIdmecanismoexplotacion">¿qu&eacute; mecanismos de coerci&oacute;n o restricci&oacute;n de la libertad se emplearon durante la explotaci&oacute;n?</label>
                            <Select
                                inputId="strIdmecanismoexplotacion"
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="Seleccione"
                                value={mecanismosexplotacionSeleccionado}
                                onChange={ActualizarMecanismosexplotacion}
                                options={mecanismosexplotacion.map((option) => ({
                                    value: String(option.id),
                                    label: option.strNombre,
                                }))}
                            />
                            <input type="hidden" {...register('datosVulneracion.strIdmecanismoexplotacion', { required: true })} />
                            {errors.datosVulneracion?.strIdmecanismoexplotacion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIddocumentosretenidos">¿existía retenci&oacute;n total o parcial de sus documentos de viaje/identidad?</label>
                            <select
                                id="intIddocumentosretenidos"
                                className="form-control"
                                {...register('datosVulneracion.intIddocumentosretenidos', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tratadocumentoretenido.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIddocumentosretenidos && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtrataredsegura">¿la v&iacute;ctima cuenta con una red de apoyo familiar o comunitaria segura y libre de riesgos en el lugar de recepci&oacute;n?</label>
                            <select
                                id="intIdtrataredsegura"
                                className="form-control"
                                {...register('datosVulneracion.intIdtrataredsegura', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {trataredsegura.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtrataredsegura && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intCantidadpersonasacargovictima"> ¿cuántas personas están a cargo econ&oacute;micamente por la v&iacute;ctima?</label>
                            <input
                                type="number"
                                id="intCantidadpersonasacargovictima"
                                className="form-control"
                                {...register('datosVulneracion.intCantidadpersonasacargovictima', { required: true, valueAsNumber: true })}
                            />
                            {errors.datosVulneracion?.intCantidadpersonasacargovictima && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdantecedentestrata">¿había antecedentes de violencia intrafamiliar, violencia basadas en g&eacute;nero o explotaci&oacute;n previa antes del evento de trata?</label>
                            <select
                                id="intIdantecedentestrata"
                                className="form-control"
                                {...register('datosVulneracion.intIdantecedentestrata', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {antecedentetrata.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdantecedentestrata && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdrequerimientoapoyoviolsexual">¿requiere activaci&oacute;n prioritaria del protocolo de atenci&oacute;n integral a v&iacute;ctimas de violencia sexual?</label>
                            <select
                                id="intIdrequerimientoapoyoviolsexual"
                                className="form-control"
                                {...register('datosVulneracion.intIdrequerimientoapoyoviolsexual', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {requerimientoapoyosexual.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdrequerimientoapoyoviolsexual && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>                        
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtipovaloracionriesgotrata">¿cu&aacute;l es la valoraci&oacute;n del nivel de amenaza o riesgo de seguridad para la v&iacute;ctima o su familia tras la salida de la situaci&oacute;n de trata?</label>
                            <select
                                id="intIdtipovaloracionriesgotrata"
                                className="form-control"
                                {...register('datosVulneracion.intIdtipovaloracionriesgotrata', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipovaloracionriesgotrata.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtipovaloracionriesgotrata && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtipoacompespecializadotrata">¿requiere acompañamiento o atención especializada en salud mental o manejo de adicciones/consumo de sustancias?</label>
                            <select
                                id="intIdtipoacompespecializadotrata"
                                className="form-control"
                                {...register('datosVulneracion.intIdtipoacompespecializadotrata', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoacompespecializadotrata.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtipoacompespecializadotrata && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtipotramiteregulacion">¿requere la victima tr&aacute;mites de regulaci&oacute;n migratoria, refugio o protecci&oacute;n internacional en Colombia?</label>
                            <select
                                id="intIdtipotramiteregulacion"
                                className="form-control"
                                {...register('datosVulneracion.intIdtipotramiteregulacion', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipotramiteregulacion.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtipotramiteregulacion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="intIdtratarequierederivacionprograma">¿requiere el caso derivaci&oacute;n a programas de protecci&oacute;n a v&iacute;ctimas y testigos de la fiscalía o la polic&iacute;a?</label>
                            <select
                                id="intIdtratarequierederivacionprograma"
                                className="form-control"
                                {...register('datosVulneracion.intIdtratarequierederivacionprograma', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tratarequierederivacionprograma.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intIdtratarequierederivacionprograma && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="strTrataexpectativavida">¿Espectativas e intereses principales de la persona para la reestructuraci&oacute;n de su proyecto de vida?</label>
                            <Select
                                inputId="strTrataexpectativavida"
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="Seleccione"
                                value={trataexpectativavidaSeleccionado}
                                onChange={ActualizarTrataExpectativaVida}
                                options={trataexpectativavida.map((option) => ({
                                    value: String(option.id),
                                    label: option.strNombre,
                                }))}
                            />
                            <input type="hidden" {...register('datosVulneracion.strTrataexpectativavida', { required: true })} />
                            {errors.datosVulneracion?.strTrataexpectativavida && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="strNecesidadinmediata">Necesidades inmediatas</label>
                            <Select
                                inputId="strNecesidadinmediata"
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="Seleccione"
                                value={tratanecesidadesinmediataSeleccionado}
                                onChange={ActualizarNecesidadInmediata}
                                options={tratanecesidadesinmediata.map((option) => ({
                                    value: String(option.id),
                                    label: option.strNombre,
                                }))}
                            />
                            <input type="hidden" {...register('datosVulneracion.strNecesidadinmediata', { required: true })} />
                            {errors.datosVulneracion?.strNecesidadinmediata && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
				<input type="hidden" {...register('datosVulneracion.int_vulneracionderechosid', { valueAsNumber: true })} />
			</div>
		</div>
	);
}
